import { ContentType, request } from "../api";
import { baseParams } from "../common";

/**
 * Актуальная цена брони у поставщика (сверяет бек): { is_price_changed, old_price, new_price, currency, ... }.
 */
export const checkPrice = async (data = {}, params = {}) => request({
  path: "/check-price",
  method: "POST",
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  secure: true,
  ...params,
});
